// Modules
import React from "react";

const DeskIcon = (props) => {
  return (
    <svg
      height="1em"
      viewBox="0 0 512 512"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M496,224h-9.38a23.882,23.882,0,0,0-.32-16.85A24,24,0,0,0,480,160H416a8,8,0,0,0-8,8v24h-8a8,8,0,0,0-8,8v24H294.82l-2.57-16H356a28.031,28.031,0,0,0,28-28V60a28.031,28.031,0,0,0-28-28H156a28.031,28.031,0,0,0-28,28V180a28.031,28.031,0,0,0,28,28h63.75l-2.57,16H112V168a8,8,0,0,0-8-8H56a8,8,0,0,0-8,8H32a8,8,0,0,0-8,8v32a8,8,0,0,0,8,8H48v8H16a8,8,0,0,0-8,8v32a8,8,0,0,0,8,8H39.02L16.05,471.08A8.012,8.012,0,0,0,24,480H40a8,8,0,0,0,7.86-6.49L86.61,272H425.39l38.75,201.51A8,8,0,0,0,472,480h16a8.012,8.012,0,0,0,7.95-8.92L472.98,272H496a8,8,0,0,0,8-8V232A8,8,0,0,0,496,224Zm-72-48h56a8,8,0,0,1,0,16H424Zm-16,32h56a8,8,0,0,1,0,16H408ZM156,192a12.01,12.01,0,0,1-12-12V60a12.01,12.01,0,0,1,12-12H356a12.01,12.01,0,0,1,12,12V180a12.01,12.01,0,0,1-12,12H289.67l-2.77-17.27A8,8,0,0,0,279,168H233a8,8,0,0,0-7.9,6.73L222.33,192Zm122.61,32H233.39l6.43-40h32.36ZM64,176H96v48H64ZM40,200V184h8v16ZM33.39,464h-.41L55.13,272H70.31Zm445.63,0h-.41L441.69,272h15.18ZM488,256H24V240H488Z"/>
    </svg>
  );
};

export default DeskIcon;